"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _luxon = require("luxon");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _chartUtils = require("../../chartUtils");

var _Icon = _interopRequireDefault(require("../Icon"));

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

require("react-vis/dist/style.css");

var _DownloadCsv = _interopRequireDefault(require("../DownloadCsv"));

var _ChartStyles = require("../ChartStyles");

var _Interaction = _interopRequireDefault(require("./Interaction"));

var _Display = _interopRequireDefault(require("./Display"));

var _hooks = require("../../hooks");

var _FixedYAxisChart = _interopRequireDefault(require("../FixedYAxisChart"));

var _Scrollable = _interopRequireDefault(require("../Scrollable"));

var _ChartLoader = _interopRequireDefault(require("../ChartLoader"));

var _useBilledKwh = require("../../hooks/useBilledKwh");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var transformToConsumptionCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('consumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'consumption'));
});
var transformToContractGenerationsMonthlyCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('contract')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'contract'));
});
var transformToExportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('exportReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'exportReading'));
});
var transformToImportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('importReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'importReading'));
});
var transformToSystemProductionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('systemProduction')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'systemProduction'));
});
var transformToPeerAdjGenerationsMonthlyCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('peer')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'peer'));
});
var transformToPeerCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('peer')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'peer'));
});
var transformToSolarMonthlyCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone, fieldName) {
  return readings.filter((0, _chartUtils.isValidReading)(fieldName)).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, fieldName));
});
var transformToSelfConsumptionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('selfConsumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'selfConsumption'));
});
var transformToBilledCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('billedKwh')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'billedKwh'));
});
var transformToEstimatedProductionCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('estimatedKwhProduction')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'estimatedKwhProduction'));
});
var transformToWeatherCorrectedCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('weatherCorrectKwhProduction')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'weatherCorrectKwhProduction'));
});

var Relative = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var MonthlyChart = function MonthlyChart(_ref) {
  var activeDataValues = _ref.activeDataValues,
      authToken = _ref.authToken,
      baseUrl = _ref.baseUrl,
      hasBattery = _ref.hasBattery,
      hasCT = _ref.hasCT,
      internalUsage = _ref.internalUsage,
      isOrangeCustomer = _ref.isOrangeCustomer,
      prospectId = _ref.prospectId,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO;

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var startISO = viewStartDateTime.toISO();
  var endISO = viewEndDateTime.toISO();
  var monthlyPerformance = (0, _hooks.useMonthlyPerformance)(prospectId, startISO, endISO, baseUrl, authToken) || [];
  var contractReadings = (0, _hooks.useContractGenMonthly)(prospectId, startISO, endISO, baseUrl, authToken, internalUsage) || [];
  var peerReadings = (0, _hooks.usePeerMonthly)(prospectId, startISO, endISO, baseUrl, authToken, internalUsage) || [];
  var peerV2Readings = (0, _hooks.usePeerMonthlyV2)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, internalUsage) || [];
  var billedKwhReadings = (0, _useBilledKwh.useBilledKwh)(prospectId, startISO, endISO, baseUrl, authToken, internalUsage && isOrangeCustomer) || [];
  var estimatedProductionReadings = (0, _useBilledKwh.useEstimatedProduction)(prospectId, startISO, endISO, baseUrl, authToken, internalUsage && isOrangeCustomer) || [];
  var weatherCorrectedReadings = (0, _useBilledKwh.useWeatherCorrectedProduction)(prospectId, startISO, endISO, baseUrl, authToken, internalUsage && isOrangeCustomer) || [];
  var isPerformanceLoading = (0, _hooks.useMonthlyPerformanceLoading)();
  var isContractLoading = (0, _hooks.useContractGenMonthlyLoading)();
  var isPeerLoading = (0, _hooks.usePeerMonthlyLoading)();
  var isPeerV2Loading = (0, _hooks.usePeerMonthlyV2Loading)();
  var isLoading = isPerformanceLoading || isContractLoading || isPeerV2Loading || isPeerLoading;
  var consumptionCoordinates = hasCT && activeDataValues.includes('consumption') ? transformToConsumptionCoordinates(monthlyPerformance, timeZone) : [];
  var contractCoordinates = activeDataValues.includes('contract') ? transformToContractGenerationsMonthlyCoordinates(contractReadings, timeZone, endMillis, startMillis) : [];
  var exportCoordinates = hasCT && activeDataValues.includes('export') ? transformToExportCoordinates(monthlyPerformance, timeZone) : [];
  var importCoordinates = hasCT && activeDataValues.includes('import') ? transformToImportCoordinates(monthlyPerformance, timeZone) : [];
  var systemProductionCoordinates = hasBattery && activeDataValues.includes('systemProduction') ? transformToSystemProductionCoordinates(monthlyPerformance, timeZone) : [];
  var peerCoordinates = activeDataValues.includes('peer') ? transformToPeerAdjGenerationsMonthlyCoordinates(peerReadings, timeZone) : [];
  var peerV2Coordinates = activeDataValues.includes('peerV2') ? transformToPeerCoordinates(peerV2Readings, timeZone) : [];
  var selfConsumptionCoordinates = hasCT && activeDataValues.includes('selfConsumption') ? transformToSelfConsumptionCoordinates(monthlyPerformance, timeZone) : [];
  var solarCoordinates = activeDataValues.includes('solar') ? transformToSolarMonthlyCoordinates(monthlyPerformance, timeZone, hasBattery ? 'batterySolar' : 'pvSolar') : [];
  var billedKwhCoordinates = activeDataValues.includes('billedKwh') ? transformToBilledCoordinates(billedKwhReadings, timeZone) : [];
  var estimatedProductionCoordinates = activeDataValues.includes('estimatedKwhProduction') ? transformToEstimatedProductionCoordinates(estimatedProductionReadings, timeZone) : [];
  var weatherCorrectedCoordinates = activeDataValues.includes('weatherCorrectKwhProduction') ? transformToWeatherCorrectedCoordinates(weatherCorrectedReadings, timeZone) : [];
  var downloadFields = [{
    label: 'Time',
    value: 'friendlyDate'
  }];

  if (hasBattery || internalUsage) {
    var systemProduction = {
      label: 'System Production (kWh)',
      value: 'systemProduction'
    };
    var batteryCharge = {
      label: 'Battery Charge (kWh)',
      value: 'charge'
    };
    var batteryDischarge = {
      label: 'Battery Discharge (kWh)',
      value: 'discharge'
    };
    downloadFields.push(systemProduction);
    downloadFields.push(batteryCharge);
    downloadFields.push(batteryDischarge);
  }

  if (!hasBattery || internalUsage) {
    var solar = {
      label: 'Solar (kWh)',
      value: 'solar'
    };
    downloadFields.push(solar);
  }

  if (hasCT || internalUsage) {
    var consumption = {
      label: 'Consumption (kWh)',
      value: 'consumption'
    };
    var selfConsumption = {
      label: 'Self Consumption (kWh)',
      value: 'selfConsumption'
    };
    var exportValue = {
      label: 'Export (kWh)',
      value: 'exportValue'
    };
    var importValue = {
      label: 'Import (kWh)',
      value: 'importValue'
    };
    downloadFields.push(consumption);
    downloadFields.push(selfConsumption);
    downloadFields.push(exportValue);
    downloadFields.push(importValue);
  }

  if (internalUsage) {
    var peerV2 = {
      label: 'Peer (kWh)',
      value: 'peerV2'
    };
    var peer = {
      label: 'Legacy Peer Adjusted (kWh)',
      value: 'peer'
    };
    var contract = {
      label: 'Contracted (kWh)',
      value: 'contract'
    };
    downloadFields.push(peerV2);
    downloadFields.push(peer);
    downloadFields.push(contract);
  }

  var displayCoordinates = {
    billedKwhCoordinates: billedKwhCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    contractCoordinates: contractCoordinates,
    estimatedProductionCoordinates: estimatedProductionCoordinates,
    exportCoordinates: exportCoordinates,
    importCoordinates: importCoordinates,
    peerCoordinates: peerCoordinates,
    peerV2Coordinates: peerV2Coordinates,
    selfConsumptionCoordinates: selfConsumptionCoordinates,
    solarCoordinates: solarCoordinates,
    systemProductionCoordinates: systemProductionCoordinates,
    weatherCorrectedCoordinates: weatherCorrectedCoordinates
  };
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)({
    billed: billedKwhCoordinates,
    consumption: consumptionCoordinates,
    contract: contractCoordinates,
    estimatedProduction: estimatedProductionCoordinates,
    exportValue: exportCoordinates,
    importValue: importCoordinates,
    peer: peerCoordinates,
    peerV2: peerV2Coordinates,
    selfConsumption: selfConsumptionCoordinates,
    solar: solarCoordinates,
    systemProduction: systemProductionCoordinates,
    weatherCorrected: weatherCorrectedCoordinates
  });
  var yTickRange = (0, _chartUtils.getMinMaxRangeFromDisplayCoordinates)(displayCoordinates);
  return /*#__PURE__*/_react["default"].createElement(Relative, null, /*#__PURE__*/_react["default"].createElement(_ChartLoader["default"], {
    isLoading: isLoading
  }), /*#__PURE__*/_react["default"].createElement(_FixedYAxisChart["default"], {
    hasNoData: false,
    yTickRange: yTickRange
  }), /*#__PURE__*/_react["default"].createElement(_Scrollable["default"], null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartWrapper, null, /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartLeft, {
    "data-tour": "chart-area"
  }, /*#__PURE__*/_react["default"].createElement(_Display["default"], {
    displayCoordinates: displayCoordinates,
    endMillis: endMillis,
    hasBattery: hasBattery,
    isLoading: isLoading,
    startMillis: startMillis,
    timeZone: timeZone,
    viewEndDateTime: viewEndDateTime,
    viewStartDateTime: viewStartDateTime
  }), /*#__PURE__*/_react["default"].createElement(_ChartStyles.FillAvailableSpace, null, /*#__PURE__*/_react["default"].createElement(_Interaction["default"], {
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    endMillis: endMillis,
    hasBattery: hasBattery,
    startMillis: startMillis,
    timeZone: timeZone
  }))), /*#__PURE__*/_react["default"].createElement(_ChartStyles.MainChartRight, null, /*#__PURE__*/_react["default"].createElement(_DownloadCsv["default"], {
    hideMobile: true,
    data: Object.values(coordinatesGroupedByTime).sort(_chartUtils.sortCoordinatesDescending).map(function (row) {
      return _objectSpread({
        friendlyDate: _luxon.DateTime.fromMillis(row.x, {
          zone: timeZone
        }).toISO()
      }, row);
    }),
    fields: downloadFields,
    fileName: "Monthly Interval"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    style: {
      height: 31,
      width: 31
    },
    name: "DownloadIcon"
  }))))));
};

MonthlyChart.propTypes = {
  activeDataValues: _propTypes["default"].arrayOf(_propTypes["default"].string),
  authToken: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  hasBattery: _propTypes["default"].bool,
  hasCT: _propTypes["default"].bool,
  internalUsage: _propTypes["default"].bool,
  isOrangeCustomer: _propTypes["default"].bool,
  prospectId: _propTypes["default"].string.isRequired,
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired
};
MonthlyChart.defaultProps = {
  activeDataValues: ['solar', 'systemProduction', 'consumption', 'selfConsumption', 'peerV2', 'contract', 'export'],
  hasBattery: false,
  hasCT: false,
  internalUsage: false,
  isOrangeCustomer: false,
  timeZone: 'local'
};
var _default = MonthlyChart;
exports["default"] = _default;